import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.1681 1 14.3348 1.00593 14.5 1.01758C18.1326 1.27396 21 4.30212 21 8V20C21 21.6569 19.6569 23 18 23H5C3.89543 23 3 22.1046 3 21V4ZM16.5 9.5C14.2909 9.5 12.5 7.70914 12.5 5.5V3H6C5.44772 3 5 3.44772 5 4L5 20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V9.5H16.5ZM18.9753 7.5C18.7408 5.13779 16.8622 3.25922 14.5 3.02469V5.5C14.5 6.60457 15.3954 7.5 16.5 7.5H18.9753Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  l as default
};
